<template>
  <div class="my-list" :class="$attrs.class">
    <a-spin :spinning="props.loadingPage">
      <slot name="pageTitle">
      </slot>
      <slot name="pageTop">
        <a-spin :spinning="props.loadingTop" v-if="props.boardList && props.boardList.length">
          <div class="board-main">
            <div class="board-item" v-for="item in props.boardList.filter(v=> v.show??true)" :style="item.style">
              <img :src="getIcon(item.icon)" alt="" class="board-icon" v-if="item.icon && getIcon(item.icon)">
              <div class="board-text">
                <div>{{ item.title || '' }}</div>
                <div class="board-num">{{ boardData[item.key] || 0 }}</div>
              </div>
            </div>
          </div>
        </a-spin>
      </slot>
      <!-- 搜索 -->
      <my-form v-if="props.search.length" ref="searchformRef" :form="props.search" @submit="search" @keyup.enter="searchformRef?.submitLoading?'':searchformRef.submit()" layout="inline" :hideLable="true">
        <template #default="{ item, form }">
          <slot name="search" :item="item" :form="form"></slot>
        </template>
        <template #footer>
          <a-form-item style="margin-right: 0;">
            <div style="white-space: nowrap;">
              <my-button type="search" @click="searchformRef.submit({ checkDateIsChange: false });" :loading="searchformRef?.submitLoading"></my-button>
              <my-button type="rest" @click="searchformRef.resetData();searchformRef.submit({ checkDateIsChange: false });" style="margin-right: 0;"></my-button>
            </div>
          </a-form-item>
        </template>
      </my-form>
      <!-- 新增 批量删除 导出 导入 等 -->
      <div class="topBtn">
        <my-button type="add" v-if="$route.meta[`${getModule}add`]&&props.api.save" @click="props.api.addFun ? props.api.addFun({ callback: addRouteQuery }) : addRouteQuery()"></my-button>
        <my-button type="import" v-if="$route.meta[`${getModule}import`]&&props.api.import" @click="visibleImport = true">{{ importOperTitle }}</my-button>
        <my-button type="export" v-if="$route.meta[`${getModule}export`]&&props.api.export" @click="exportFun"></my-button>
        <slot name="topBtn"></slot>
        <!-- <my-button type="delete" v-if="$route.meta[`${getModule}delete`]&&props.api.batchDelete" :disabled="!selectedRowKeys.length" @click="deleteFun()"></my-button> -->
        <span style="float: right;">
        <a-popover trigger="hover" placement="bottom">
          <template #content>
            <div class="column-list" v-for="(item, i) in showColumn" :key="item.key ?? 'showColumn'+i" @mouseenter="item.showAction = true;" @mouseleave="item.showAction = false;">
              <a-checkbox v-model:checked="item.show" @change="saveColumnSort">{{ item.title }}</a-checkbox>
              <div class="action-div">
                <UpOutlined v-show="item.showAction" class="action-btn" :class="!i ? 'disabled' : ''" @click="sortColumnAction(item, i, true)" />
                <DownOutlined v-show="item.showAction" class="action-btn" :class="i === showColumn.length - 1 ? 'disabled' : ''" @click="sortColumnAction(item, i, false)" />
              </div>
            </div>
          </template>
          <a-button><eye-outlined /></a-button>
        </a-popover>
      </span>
      </div>
      <!-- 表格 -->
      <a-config-provider :component-size="componentSize" :locale="zhCN">
        <a-table v-if="props.api && props.api.page"
                 :dataSource="dataSource.length?dataSource:props.dataSource"
                 :columns="columns.filter(v=>v.show)"
                 @change="handleTableChange"
                 :pagination="hasPagination ? pagination : false"
                 :row-selection="$attrs.rowSelection === false ? null : { preserveSelectedRowKeys: true, selectedRowKeys: selectedRowKeys, onChange: onSelectRow, onSelect: rowSelect, hideSelectAll: $attrs.rowSelectRadio, ...($attrs.rowSelection || {}) }"
                 :rowKey="props.rowKey"
                 :scroll="{ x: '100%', y: `calc(100vh - 427px)` }"
                 :loading="tableLoading"
                 @resizeColumn="(width, col) => col.width = width"
                 style="width: 100%;"
                 v-bind="tableConfig">
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.key === 'index' || column.dataIndex === 'index'">
            <span>
              {{ (pagination.current - 1) * pagination.pageSize +  index + 1 }}
            </span>
            </template>
            <template v-else-if="column.type === 'img'">
              <a-image-preview-group v-if="record[column.key || column.dataIndex]">
                <template v-if="typeof(record[column.key || column.dataIndex])=='string'&&!column.setImgs">
                  <a-image :width="60" :src="record[column.key || column.dataIndex]" style="object-fit:cover;" />
                </template>
                <template v-else>
                  <div style="height:60px;width:60px;">
                    <a-image v-for="(img, imgIndex) in column.setImgs ? column.setImgs(record[column.key || column.dataIndex]) : record[column.key || column.dataIndex]" :width="60" :height="60" :src="img" />
                  </div>
                </template>
              </a-image-preview-group>
            </template>
            <template v-else-if="column.type === 'time' || column.type === 'timeHMS'">
              {{ dateFormat(getColumnData(record, column), column.type === 'timeHMS' ? 'YYYY/MM/DD HH:mm' : column.format) }}
            </template>
            <template v-else-if="column.type === 'percent'">
              {{ getPercentStr(getColumnData(record, column)) }}
            </template>
            <template v-else-if="column.type === 'empty'">
              {{ getColumnData(record, column) || '- -' }}
            </template>
            <template v-else-if="column.key === 'action' || column.dataIndex === 'action'">
              <div style="white-space: nowrap;">
                <my-button type="link" v-if="props.api.pageByID&&(!props.api.hidePreview || props.api.hidePreview(record) !== true)" @click="addRouteQuery({ type: 'preview', data: record })" size="small">查看</my-button>
                <my-button type="link" v-if="$route.meta[`${getModule}update`]&&props.api.update && (!props.api.hideUpdate || props.api.hideUpdate(record) !== true)" @click="addRouteQuery({ type: 'update', data: record })" size="small">{{ props.api.updateButtonLabel || '编辑'}}</my-button>
                <my-button type="link" v-if="$route.meta[`${getModule}approval`]&&props.api.approval && (!props.api.hideApproval || props.api.hideApproval(record) !== true)" @click="addRouteQuery({ type: 'approval', data: record })" size="small">{{ props.api.approvalButtonLabel || '审批'}}</my-button>
                <slot name="action" :column="column" :record="record" :index="index"></slot>
                <my-button type="link" v-if="$route.meta[`${getModule}delete`]&&props.api.batchDelete && (!props.api.hideDelete || props.api.hideDelete(record) !== true)" @click="deleteFun(record)" size="small" danger>删除</my-button>
              </div>
            </template>
            <slot name="table" :column="column" :record="record" :index="index"></slot>
          </template>
          <template #summary v-if="props.api.pageSummary">
            <a-table-summary-cell style="text-align: center;" v-for="(item, index) in summaryColumns" :key="index">
              <template v-if="index === ($attrs.rowSelection !== false ? 1 : 0)">合计</template>
              <template v-else-if="item.sumKey">
                {{ tableSummaryData ? tableSummaryData[item.sumKey] : sumArray((dataSource.length?dataSource:props.dataSource).map(item1 => item1[item.sumKey || item.key]), item.decimalPlaces) }}
              </template>
            </a-table-summary-cell>
          </template>
          <template #footer v-if="$slots.tableFooter">
            <slot name="tableFooter"></slot>
          </template>
          <!--        <template #expandIcon="{ expanded, onExpand, record }">-->
          <!--          <div class="ant-table-row-expand-icon">-->
          <!--            <DownOutlined v-if="expanded" />-->
          <!--            <RightOutlined v-else />-->
          <!--          </div>-->
          <!--        </template>-->
        </a-table>
      </a-config-provider>
    </a-spin>
    <!-- 表单 -->
    <component :is="{ drawer: 'my-drawer', modal: 'my-modal', page: 'my-page-modal' }[props.modalType] || 'my-modal'"
               :title="`${$route.meta.title} ${FormTitle}`"
               v-model="visibleForm"
               :bodyStyle="{ paddingRight: '58px' }"
               :width="modalWidth"
               @cancel="formClose"
               @close="formClose">
      <a-spin :spinning="spinningForm" tip="加载中...">
        <my-form ref="formRef" :form="form" @submit="submit" :show="visibleForm" :showSubmit="false" :whiteList="false" :openType="openType" :title="FormTitle" :width="modalWidth" :formStyle="formStyle" :labelWidth="$attrs.labelWidth" :form-tab-names="$attrs.formTabNames">
          <template #default="{ item, form, show, disabled, openType }">
            <slot name="form" :item="item" :form="form" :show="show" :disabled="disabled" :openType="openType"></slot>
          </template>
        </my-form>
      </a-spin>
      <template #footer>
        <my-button v-if="openType!='preview'" @click="formRef.submit({})" :loading="formRef?.submitLoading">提交</my-button>
        <my-button v-if="props.api.draft && (openType=='add' || (openType=='update' && formRef?.formList?.auditStatus == 3))" @click="formRef.submit(true, false)" :loading="formRef?.submitLoading">保存</my-button>
<!--        <my-button v-if="openType!='preview' && openType!='approval' && openType!='update'" type="rest" @click="formRef.resetData();formRef.clearValidate()"></my-button>-->
      </template>
      <template #right>
        <slot name="modalRight" :form="formRef?.formList || {}" :show="visibleForm" :openType="openType"></slot>
      </template>
    </component>
    <!-- 导出 -->
    <my-modal title="导出" v-model="visibleExport" :bodyStyle="{ paddingRight: '58px' }" :width="700">
      <my-form v-if="props.export.length" ref="exportFormRef" :form="props.export" @submit="exportFun">
        <template #default="{ item, form, show, disabled }">
          <slot name="export" :item="item" :form="form" :show="show" :disabled="disabled"></slot>
        </template>
        <template #footer>
          <span></span>
        </template>
      </my-form>
      <template #footer>
        <my-button :loading="exportFormRef?.submitLoading" @click="exportFormRef.submit(true)">确定导出</my-button>
        <my-button @click="visibleExport = false;exportFormRef.resetData();exportFormRef.clearValidate()">取消</my-button>
      </template>
    </my-modal>
    <!-- 导入 -->
    <my-modal :title="importOperTitle" v-model="visibleImport" :bodyStyle="{ paddingRight: '58px' }" width="80%">
      <a-spin :spinning="spinningImport" tip="加载中...">
        <div style="padding-bottom: 20px;">
          <input ref="importFile" type="file" style="display:none;" @change="importPreview" accept=".xls,.xlsx"/>
          <my-button @click="$refs.importFile.click()">选择导入文件</my-button>
          <a v-if="props.api.importTemplate" :href="props.api.importTemplate" target="_blank" style="margin-left: 20px;">下载{{props.api.importTemplateName}}模板</a>
        </div>
        <div class="formItemTitle">
          <div class="columnIcon"></div>
          可导入的数据
        </div>
        <a-table :dataSource="importData.successList || []"
                 :columns="importSuccessColumns"
                 rowKey="index"
                 style="width: 100%;"></a-table>
        <div class="formItemTitle">
          <div class="columnIcon"></div>
          导入异常的数据
        </div>
        <a-table :dataSource="importData.errorList || []"
                 :columns="importErrorColumns"
                 rowKey="index"
                 style="width: 100%;"></a-table>
      </a-spin>
      <template #footer>
        <my-button :loading="importLoading" @click="importFun()">确定导入</my-button>
        <my-button @click="importData={};$refs.importFile.click();">重新导入</my-button>
      </template>
    </my-modal>
  </div>
</template>

<script>
  import myPageModal from '../my-page-modal/index.vue';
  // declare additional options
  export default {
    inheritAttrs: false,
    components: {
      myPageModal
    }
  }
</script>
<script setup>
  import { ref, reactive, onMounted, onUnmounted, onActivated, onDeactivated, defineProps, defineExpose, defineEmits, watchEffect, watch, isReactive, nextTick, computed, useAttrs, triggerRef } from 'vue';
  import { message, Modal } from 'ant-design-vue';
  import { EyeOutlined, DownOutlined, UpOutlined } from "@ant-design/icons-vue";
  import {dateFormat, getPercentStr, getProperty, isObjectEqual, sumArray} from '@/utils';
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import { useRouter, useRoute } from 'vue-router';

  const router = useRouter();
  const route = useRoute();

  const props = defineProps({
    search: {
      type: Array,
      default: () => []
    },
    form: {
      type: Array,
      default: () => []
    },
    previewForm: {
      type: Array,
    },
    export: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    importColumns: {
      type: Array,
      default: () => []
    },
    importErrorColumns: {
      type: Array,
      default: () => []
    },
    api: {
      type: Object,
      default: () => ({})
    },
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    rowKey: {
      type: [String],
      default: 'id'
    },
    modalWidth: {
      type: [Number, String],
    },
    modalType: {
      type: [String],
      default: 'page'
    },
    target: {
      type: [String],
      default: ''
    },
    setUrlParam: {
      type: [Function],
    },
    onBeforeFormInit: {
      type: Function,
      default: () => Promise.resolve()
    },//打开表单前
    onBeforeSubmit: {
      type: Function,
      default: () => Promise.resolve()
    },//提交表单前
    onAfterSubmit: {
      type: Function,
    },//提交表单前
    onBeforeFormClose: {
      type: Function,
      default: () => Promise.resolve()
    },//关闭表单前
    onSubmitError: {
      type: Function,
      default: () => Promise.resolve()
    },//关闭表单前
    pageTitle:{
      type: String,
      default: '',
    },
    //全局loading
    loadingPage:{
      type: Boolean,
      default: false
    },
    //列表头部看板数据loading
    loadingTop:{
      type: Boolean,
      default: false
    },
    //列表头部看板数据
    boardList: {
      type: Array,
      default: () => []
    },
    boardData:{
      type: Object,
      default: () => ({})
    },
  });

  const emits = defineEmits(['init', 'afterFormInit', 'formInit', 'afterSubmit']);

  const attrs = useAttrs();

  const getModule = computed(() => props.api.module ? `${props.api.module}_` : '');

  //查询和表单ref对象
  const searchformRef = ref();
  const formRef = ref();

  const componentSize = ref('middle');
  const resizeFun = () => componentSize.value = window.innerWidth > 1600 ? 'middle' : 'small';

  const pageName = ref(route.name);
  // 用于跟踪组件是否处于激活状态
  const isActive = ref(true);
  
  // 监听组件激活和非激活状态
  onActivated(() => {
    isActive.value = true;
  });
  
  onDeactivated(() => {
    isActive.value = false;
  });
  //初始化方法
  onMounted(() => {
    resizeFun();
    window.addEventListener('resize', resizeFun);
    if (searchformRef.value) {
      searchformRef.value.initData(searchformRef.value?.formList);
    }
    // 如果路由中带参数，则将搜索事件放入宏任务队列中执行，否则立即执行
    if (route.query) {
      setTimeout(() => {
        search({});
      }, 0)
    } else {
      search({});
    }

    setColumnSort();
  });
  //销毁事件
  onUnmounted(() => {
    window.removeEventListener('resize', resizeFun);
  });

  //表头数据
  const columns = ref([]);
  const summaryColumns = computed(() => {
    // 递归函数，用于展开所有子列并形成扁平数组
    const flattenColumns = (cols) => {
      let result = [];
      cols.forEach(col => {
        // 如果当前列有子列，递归处理子列并将结果添加到结果数组中
        if (col.children && Array.isArray(col.children) && col.children.length > 0) {
          result = result.concat(flattenColumns(col.children));
        } else {
          // 将当前列添加到结果中
          result.push(col);
        }
      });
      return result;
    };

    const flattenedCols = flattenColumns(columns.value.filter(item => item.show));
    return attrs.rowSelection === false ? flattenedCols : [{}, ...flattenedCols];
  })
  const importSuccessColumns = ref([]);
  const importErrorColumns = ref([]);

  const applyDefaultColumnProperties = (column, defaultData = {}) => {
    // 为列应用默认属性
    const defaultColumn = Object.assign({}, defaultData, column);
    
    // 如果存在子列，则递归处理子列
    if (column.children && Array.isArray(column.children)) {
      defaultColumn.children = column.children.map(child => applyDefaultColumnProperties(child, defaultData));
    }
    
    return defaultColumn;
  };

  const getColumnData = (record, column) => getProperty(record, Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : (column.middleKey ? `${column.middleKey}.${column.dataIndex || column.key}` : column.dataIndex || column.key)) ?? column.default ?? ''

  watchEffect(() => {
    columns.value = props.columns.map(column => applyDefaultColumnProperties(column, { ellipsis: true, width: 150, minWidth: 100, show: true, resizable: true, align: 'center' }));
    if (props.importColumns.length) {
      importSuccessColumns.value = [...props.importColumns];
      importErrorColumns.value = [...props.importColumns, { title: '异常原因', dataIndex: 'errorMessage', key: 'errorMessage', ellipsis: true, width: 150 }];
    }
    if (props.importErrorColumns.length) {
      importErrorColumns.value = [...props.importErrorColumns];
    }
    if (props.api.import && !props.importErrorColumns.length && !props.importColumns.length) {
      importSuccessColumns.value = props.columns.map(column => applyDefaultColumnProperties(column, { ellipsis: true, width: 150, show: true }));
      importErrorColumns.value = [...importSuccessColumns.value, { title: '异常原因', dataIndex: 'errorMessage', key: 'errorMessage', ellipsis: true, width: 150 }];
    }
    if (props.columns[0] && props.columns[0].key == 'index') {//如果第一列是index 给默认宽度
      !props.columns[0].width && (columns.value[0].width = 80);
      columns.value[0].fixed = 'left';
    }
    const last = props.columns[props.columns.length - 1];
    if (last && last.key == 'action') {//如果最后一列是操作栏 给默认宽度
      columns.value[columns.value.length - 1].width = last.width || 200;
      columns.value[columns.value.length - 1].fixed = 'right';
      columns.value[columns.value.length - 1].ellipsis = false;
    }
  });

  const showColumn = computed(() => columns.value.filter(v => v.key !== 'action'));

  const sortColumnAction = (item, index, isUpper) => {
    if (isUpper && !index || !isUpper && index === showColumn.value.length - 1) return;
    const newIndex = isUpper ? index - 1 : index + 1;
    // columns.value[index] = columns.value[newIndex];
    // columns.value[newIndex] = item;
    [columns.value[index], columns.value[newIndex]] = [columns.value[newIndex], columns.value[index]];
    saveColumnSort();
  }

  const saveColumnSort = () => {
    const list = showColumn.value.map(item => ({key:item.key,show:item.show}));
    localStorage.setItem(route.name, JSON.stringify(list))
  }

  const setColumnSort = () => {
    const keysStrList = localStorage.getItem(route.name) || '';
    if (!keysStrList || keysStrList.indexOf('{') === -1) {
      return;
    }
    const keys = keysStrList ? JSON.parse(keysStrList) : [];
    if (!keys.length) {
      return;
    }
    const temp = sortHeadersByKeys(columns.value, keys);
    temp.forEach((item, index) => {
      columns.value[index] = item;
    });
  }

  /**
   * 根据 key 数组顺序重新排列表头数据
   * @param {Array} headers - 表头数据数组，每个元素是一个对象，包含 key 和其他属性
   * @param {Array} keys - 用于排序的 key 数组
   * @returns {Array} 重新排序后的表头数据
   */
  function sortHeadersByKeys(headers, keys) {
    // 创建一个 Map 用于快速查找 key 的顺序
    const keyOrderMap = new Map();
    const keyShowMap = new Map();
    keys.forEach((key, index) => {
      keyOrderMap.set(key.key, index);
      keyShowMap.set(key.key,key.show);
    });

    // 分离在 keys 中的表头和不在的表头
    const headersInKeys = [];
    const headersNotInKeys = [];

    headers.forEach(header => {
      if (keyOrderMap.has(header.key)) {
        headersInKeys.push(header);
      } else {
        headersNotInKeys.push(header);
      }
    });

    // 对在 keys 中的表头进行排序
    headersInKeys.forEach((item)=>{
      item.show = keyShowMap.get(item.key);
    })
    headersInKeys.sort((a, b) => {
      return keyOrderMap.get(a.key) - keyOrderMap.get(b.key);
    });

    // 合并结果：排序后的表头 + 不在 keys 中的表头
    return [...headersInKeys, ...headersNotInKeys];
  }
  
  // 表格变化处理（排序、筛选等）
  const handleTableChange = (page, filters, sorter) => {
    if (!goPageOne) {
      pagination.current = page.current;
    } else {
      goPageOne = false;
      pagination.current = 1;
    }
    pagination.pageSize = page.pageSize;
    // 拼接排序参数
    const extra = {};
    if (sorter?.column?.sorter && sorter?.column?.sorterOptions?.sorterKey) {
      extra[sorter.column.sorterOptions.sorterKey] = sorter.column.sorterOptions[sorter.order];
    }
    search({ extra, current: pagination.current });
  };

  const getIcon = (icon) => {
    try {
      return require(`@/assets${icon}`);
    } catch (error) {
      console.log(error,'error');
    }
  };
  
  //查询方法
  const dataSource = ref([]);
  const tableLoading = ref(false);
  let exportParams = {};//导出用 记录搜索的条件
  const fixedParams = ref({});//用于外部联动搜索 重置不清空
  // 存储列表合计的数据
  const tableSummaryData = ref({});
  const lastSearchParams = ref({});

  nextTick(() => lastSearchParams.value = searchformRef.value?.formList);

  const search = ({ data = searchformRef.value?.formList || {}, extra = {}, reset = null, current = 1 }) => {
    if (!props?.api?.page) {
      return;
    }
    exportParams = JSON.parse(JSON.stringify({ ...data, ...fixedParams.value}));
    tableLoading.value = true;
    pagination.current = current;
    const searchData = { pageNo: pagination.current, pageSize: pagination.pageSize, ...data, ...extra, ...fixedParams.value };
    Object.keys(searchData).map(key => {
      !searchData[key] && searchData[key] !== 0 && (delete searchData[key]);//删除空字符串的参数
    });
    props.api.page(searchData).then(res => {
      if (pagination.current != 1 && res.data.records && !res.data.records.length) {//在搜索框输入内容后 点击翻页 导致出现 例如只有第一页有数据 当前在第二页 出现空白
        search({});
        return;
      }
      // 当查询条件改变时，点击搜索时清除上一次选择的选项
      if (!isObjectEqual(lastSearchParams.value, data) && selectedRowKeys.value && selectedRowKeys.value.length) {
        selectedRowKeys.value = [];
        lastSearchParams.value = { ...data };
      }
      if (res.data && res.data.records) {
        hasPagination.value = true;
        dataSource.value = res.data.records;
        pagination.total = res.data.total * 1;
      } else if (Array.isArray(res.data)) {
        hasPagination.value = false;
        dataSource.value = res.data;
        pagination.total = res.data.length;
      }
      props.api.pageSummary && props.api.pageSummary({ ...data, ...extra, ...fixedParams.value }).then(res => {
        tableSummaryData.value = res.data || undefined;
      });
    }).catch((err) => {
      message.error(err?.msg || `获取数据失败，请稍后重试`);
    }).finally(() => {
      tableLoading.value = false;
      reset && reset(false);
    });
  };
  //分页参数
  let goPageOne = false;
  const hasPagination = ref(true);
  const pagination = reactive({
    current: 1,
    pageSize: 10,
    total: 0,
    showTotal: (total) => `共${total}条记录`,
    showSizeChanger: true,
    showQuickJumper: true,
    onShowSizeChange: (current, pageSize) => {
      //console.log('showSizeChange', current, pageSize);
      goPageOne = true;
      pagination.pageSize = pageSize;
    },
    ...(attrs.paginationConfig || {}),
  });
  //表格勾选列
  const selectedRowKeys = ref([]);
  const selectedRows = ref([]);
  const onSelectRow = (keys, rows) => {
    if (!attrs.rowSelectRadio) {
      selectedRows.value = rows;
      selectedRowKeys.value = keys;
    }
  };
  const rowSelect = record => {
    if (!attrs.rowSelectRadio) {
      return;
    }
    if (selectedRowKeys.value[0] != record[props.rowKey]) {
      selectedRows.value = [record];
      selectedRowKeys.value = [record[props.rowKey]];
    } else {
      selectedRows.value = [];
      selectedRowKeys.value = [];
    }
  };

  //删除方法
  const deleteFun = (record) => {
    const params = {};
    params[props.rowKey] = record[props.rowKey];
    Modal.confirm({
      title: '提示',
      content: props.api.deleteContent || '确认删除！',
      okType: 'danger primary',
      onOk() {
        //props.api.batchDelete(id ? [id] : selectedRowKeys.value).then(res => {
        props.api.batchDelete(params).then(res => {
          message.success('删除成功');
          search({ current: dataSource.value.length == selectedRowKeys.value.length ? 1 : pagination.current });
          selectedRowKeys.value = [];
        }).catch(err => {
          message.error(err.errorMsg || err?.msg || `删除失败`);
        });
      },
    });
  };

  watch(() => route.query, (query) => {
    const { supportRefresh, type, title, routeName } = query;
    // 只有当组件是当前激活的实例时才处理路由参数变化
    if (supportRefresh && routeName == pageName.value && isActive.value) {
      const data = { ...query };
      delete data.type;
      delete data.title;
      delete data.routeName;
      delete data.supportRefresh;
      nextTick(() => {
        initFormObj({ type, data, title });
      });
    }
  }, { immediate: true });
  const addRouteQuery = ({ type = 'add', data, title = '' } = {}) => {
    const addKey = {};
    if (data) {
      addKey[props.rowKey] = data[props.rowKey];
    }
    let params = {};
    if (props.setUrlParam) {
      params = props.setUrlParam(data) || {};
    }
    const _time = new Date().getTime();
    if (props.target == '_blank') {
      window.open(appendParamsToCurrentUrl({ type, title, ...addKey, routeName: route.name, supportRefresh: 1, _time, ...params }), '_blank');
    } else if (props.target == 'none') {
      nextTick(() => {
        initFormObj({ type, data, title });
      });
    } else {
      // 使用replace替代push，避免创建多个历史记录
      router.push({
        path: route.path,
        query: {
          ...route.query,
          type,
          title,
          ...addKey,
          routeName: route.name,
          supportRefresh: 1,
          _time,
          ...params
        }
      });
    }
  }

  /**
   * 获取当前URL并拼接参数
   * @param {Object} params - 要拼接的参数对象
   * @returns {string} 拼接后的完整URL
   */
  const appendParamsToCurrentUrl = (params) => {
    // 获取当前URL（不包括哈希部分）
    const currentUrl = window.location.href.split('#')[0];

    // 创建URL对象便于操作
    const url = new URL(currentUrl);

    // 添加新参数
    Object.keys(params).forEach(key => {
      url.searchParams.set(key, params[key]);
    });

    // 返回完整的URL字符串
    return url.toString();
  }

  //初始化表单
  const visibleForm = ref(false);
  const spinningForm = ref(false);
  const FormTitle = ref('新增');
  const form = ref(props.form);
  const openType = ref('');
  const submitFun = ref(null);
  const modalWidth = computed(() => {
    if (props.modalWidth) {
      return props.modalWidth;
    }
    return { drawer: 700, modal: 700, page: 1000 }[props.modalType];
  });
  const formStyle = computed(() => {
    if (props.modalType === 'page') {
      return { maxWidth: '100%' };
    }
    return { };
  })
  // 这里记录需要重新刷新的组件名称
  const reloadComponentsList = [
    'my-treeSelect',
    'my-treeSelects',
    'a-tree-select',
    'custom-treeSelect',
  ];
  const initForm = (type = 'add', record = {}, fun = null, detailFun = props.api?.pageByID, title = '', formList = null, afterSubmit, autoSearch = true) => {
    submitFun.value = fun;
    if (formList) {
      form.value = formList;
    } else if (type == 'preview' && props.previewForm) {
      form.value = props.previewForm;
    } else {
      // 为需要重新渲染的组件添加key属性
      form.value = props.form.map(item => {
        // 检查组件是否在需要重新渲染的列表中
        if (reloadComponentsList.includes(item.type)) {
          return {
            ...item,
            attrs: {
              ...(item.attrs || {}),
              key: `${type}_${Date.now()}` // 添加唯一key确保重新渲染
            }
          };
        }
        return item;
      });
    }
    openType.value = type;
    visibleForm.value = true;
    spinningForm.value = true;
    const extend = { afterSubmit, autoSearch };
    nextTick(() => {
      (props.onBeforeFormInit({ data: record, type }) || Promise.resolve()).then(() => {
        let updateButtonLabel = type == 'update' && props.api.updateButtonLabel ? props.api.updateButtonLabel : undefined;
        FormTitle.value = title || updateButtonLabel || { add: '新增', update: '编辑', preview: '查看', approval: '审批' }[type];
        if (detailFun && (type == 'update' || type == 'preview' || type == 'approval') && formRef.value) {
          detailFun(record, type).then(res => {
            nextTick(() => {
              emits('formInit', { type, data: res.data, title });
              formRef.value.initData(res.data, type, extend);
              emits('afterFormInit', { type, show: formRef.value.show, disabled: formRef.value.disabled, data: formRef.value.formList, title, record });
              spinningForm.value = false;
            });
          }).catch((err) => {
            message.error(err?.msg || `获取数据失败，请稍后重试`);
            visibleForm.value = false;
            spinningForm.value = false;
            search({});
            if (props.modalType === 'page' || props.modalType === 'modal') {
              router.go(-1);
            }
          });
        } else {
          nextTick(() => {
            emits('formInit', { type, data: record, title });
            const cloneData = JSON.parse(JSON.stringify(record));//防止元数据被改变
            formRef.value.initData(cloneData, type, extend);
            emits('afterFormInit', { type, show: formRef.value.show, disabled: formRef.value.disabled, data: formRef.value.formList, title });
            spinningForm.value = false;
          });
        }
      }).catch(() => {
        visibleForm.value = false;
        spinningForm.value = false;
        if (props.modalType == 'page') {
          router.go(-1);
        }
      });
    });
  };
  const initFormObj = (...arg) => {
    if (typeof arg[0] == 'object') {
      let param = arg[0];
      initForm(param.type, param.data, param.fun, param.detailFun, param.title, param.formList, param.afterSubmit, param.autoSearch);
    } else {
      initForm(...arg);
    }
  }
  //表单点击遮罩层或左上角叉或取消按钮的回调
  const formClose = e => {
    visibleForm.value = true;
    const cloneData = JSON.parse(JSON.stringify(formRef.value?.formList));//防止提交失败 但是元数据已被改变
    (props.onBeforeFormClose({ type: openType.value, data: cloneData, title: FormTitle.value }) || Promise.resolve()).then(res => {
      visibleForm.value = res === false;
      if (route.query.supportRefresh) {
        router.go(-1);
      }
    });
  }

  //新增 编辑 等
  const submit = ({ data, type, reset, afterSubmit, autoSearch }) => {
    type = type || openType.value;
    const cloneData = JSON.parse(JSON.stringify(data));//防止提交失败 但是元数据已被改变
    (props.onBeforeSubmit({ type, data: cloneData }) || Promise.resolve(cloneData)).then(newData => {
      const fun = submitFun.value || { add: props.api.save, update: props.api.update, approval: props.api.approval, draft: props.api.draft }[type];
      fun(newData || cloneData).then(res => {
        setTimeout(() => { visibleForm.value = false; }, 100);
        setTimeout(() => { reset && reset(); }, 500);
        if (props.target == '_blank') {
          const newQuery = { ...route.query };
          delete newQuery.type;
          delete newQuery.title;
          delete newQuery[props.rowKey];
          delete newQuery.supportRefresh;
          delete newQuery.routeName;
          delete newQuery._time; 

          router.push({
            path: route.path,
            query: newQuery
          });
        } else if (route.query.supportRefresh) {
          router.go(-1);
        }

        if (afterSubmit && typeof afterSubmit == 'function') {
          message.success(`${type == 'draft' ? '保存' : FormTitle.value}成功`);
          afterSubmit({ search, openType: openType.value, data: res.data });
        } else if (props.onAfterSubmit && typeof props.onAfterSubmit == 'function') {
          let interceptDefault = props.onAfterSubmit({ search, openType: openType.value, data: res.data });
          if (!interceptDefault) {
            message.success(`${type == 'draft' ? '保存' : FormTitle.value}成功`);
          }
          autoSearch && search({});
        } else {
          message.success(`${type == 'draft' ? '保存' : FormTitle.value}成功`);
          emits('afterSubmit', openType.value);
          autoSearch && search({});
        }
      }).catch(err => {
        message.error(err?.msg || `${type == 'draft' ? '保存' : FormTitle.value}失败`);
        if (err.code === 2001 || err.code === 2002) {
          props.onSubmitError && props.onSubmitError({ data: formRef.value.formList, errorData: err.data });
        }
        reset && reset(false);
      });
    }).catch((e) => {
      // console.log('onBeforeSubmit:catch');
      // console.log(e);
      reset(false);
    });
  };
  //导出
  const visibleExport = ref(false);
  const exportFormRef = ref();
  const exportFun = ({ data, type, reset }) => {
    Modal.confirm({
      title: '提示',
      content: `将导出已查询出的数据！`,
      onOk() {
        const params = { ...exportParams };
        // 如果需要支持部分导出，需要在api中配置partyExportKey，值为后端接口中接收批量导出的字段
        if (props.api.partyExportKey && selectedRowKeys.value && selectedRowKeys.value.length) {
          params[props.api.partyExportKey] = selectedRowKeys.value;
        }
        props.api.export(params).then(res => {
          if (res.headers['content-disposition']) {
            message.success(`导出成功`);
            //获取文件名称与文件类型
            const filename = decodeURI(res.headers['content-disposition'].split('filename=')[1].split('.')[0]);
            const contentType = res.headers['content-type'];
            const url = window.URL.createObjectURL(new Blob([res.data], {
              type: contentType
            }));
            const link = document.createElement('a');
            link.style.display = "none";
            link.download = filename;
            link.href = url;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } else {
            const reader = new FileReader()
            reader.onload = async () => {
              const err = JSON.parse(reader.result);
              message.error(err?.msg || `导出失败`);
            }
            reader.readAsText(res.data);
          }
        }).catch(err => {
          message.error(err?.msg || `导出失败`);
        });
      }
    });
  };
  //导入
  const visibleImport = ref(false);
  const spinningImport = ref(false);//加载数据loading
  const importLoading = ref(false);//提交按钮的loading
  const importData = ref({ successList: [], errorList: [] });
  const importFile = ref(null);
  const importOperTitle = computed(() => props.api.importButtonTitle || '导入')
  watch(visibleImport, (v) => {
    v && (importData.value = { successList: [], errorList: [] });
  })
  const importPreview = (e) => {
    //console.log(e.target.files[0]);
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    spinningImport.value = true;
    props.api.importPreview(formData).then(res => {
      importData.value = res.data;
    }).catch(err => {
      message.error(err?.msg || `${importOperTitle.value}失败`);
      importData.value = [];
    }).finally(() => {
      importFile.value.value = '';
      spinningImport.value = false;
    });
  }
  const importFun = () => {
    if (!importData.value.successList?.length) {
      message.error(`无可${importOperTitle.value}数据`);
      return;
    }
    importLoading.value = true;
    props.api.import({ [props.api.importKey || 'commodityBatchImportList']: importData.value.successList }).then(res => {
      visibleImport.value = false;
      message.success(`${importOperTitle.value}成功`);
      searchformRef.value.resetData();
      search({});
    }).catch(err => {
      message.error(err?.msg || `${importOperTitle.value}失败`);
    }).finally(() => {
      importLoading.value = false;
    });
  }

  const quick = ({ data = {}, msg = '操作', type = 'update', fun, okType, callback }) => {
    Modal.confirm({
      title: '提示',
      content: `确认${msg}！`,
      okType: okType || 'primary',
      onOk() {
        (fun || { add: props.api.save, update: props.api.update }[type])(data).then(res => {
          if (callback) {
            callback(true);
          } else {
            message.success(`${msg}成功`);
            search({ current: pagination.current });
          }
        }).catch((err) => {
          message.error(err && err.msg ? err.msg : `${msg}失败`);
        });
      },
      onCancel() {
        if (callback) {
          callback(false);
        } else {
          search({ current: pagination.current });
        }
      }
    });
  }

  //向父级抛出的属性 方法
  defineExpose({
    search,
    selectedRowKeys,//表格勾选的id集合
    selectedRows,//表格勾选的行集合
    initForm: initFormObj,//手动调用新增和编辑
    quick,//快捷调用编辑接口 例如启用禁用
    dataSource,//表格数据
    formRef,
    searchformRef,
    fixedParams
  });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-list {
    flex: auto;
    width: 100%;
  }

  .topBtn {
    padding: 10px 0;
  }

  .formItemTitle {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    padding: 8px 20px;
    background-color: rgba(24, 144, 255, 0.1);
    margin-right: -30px;
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 18px;
  }

  .columnIcon {
    display: inline-block;
    width: 4px;
    height: 20px;
    border-radius: 3px;
    background-color: #1890ff;
    margin-right: 5px;
  }
  .modalFooter {
    text-align: center;
  }
  .column-list {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    .action-div {
      display: flex;
      display: -webkit-flex;
      gap: 4px;
      width: 32px;
      align-items: center;
    }
    .action-btn {
      color: #1890ff;
      cursor: pointer;
    }
    .disabled {
      color: #999999;
      cursor: default;
    }
  }

  :deep(.ant-table-middle .ant-table-summary) {
    .ant-table-cell {
      height: 49px;
      padding: 12px 8px;
    }
  }

  :deep(.ant-table-small .ant-table-summary) {
    .ant-table-cell {
      height: 41px;
      padding: 8px;
    }
  }

  .board-main{
    display: flex;
    align-items: center;
    padding: 12px 16px 24px;
    gap: 30px;
    .board-item {
      display: flex;
      padding: 16px;
      border-radius: 8px;
      min-width: 160px;
      .board-icon{
        width: 44px;
        height: 49px;
      }
      .board-text{
        font-size: 12px;
        color: #515d6cb3;
        .board-num{
          font-size: 20px;
          font-weight: 500;
          color: #515d6c;
          line-height: 28px;
          letter-spacing: 0.83px;
        }
      }
    }
  }

  @media screen and (max-width: 1600px) {
    .my-list .board-main .board-item {
      min-width: 120px;
    }
  }
</style>
